import { initCycleGallery } from "./widgets/gallery";
import { initHospitalMap } from "./widgets/googleMaps";
import { setupZipDisplay } from "../loaders/zip-display-setup";
import { setupProductSearch } from "./widgets/product-search";
import { setupNavigation } from "./components/navigation";
import { getUrlVars } from "./modules/query-string";

jQuery(function ($: JQueryStatic) {
  initCycleGallery($);
  initHospitalMap();

  setupTrustWave();

  // setup product search elements
  setupProductSearch($);

  $(".main-content:has(div.gallery)").addClass("home-page");
  $("#hgsmain:has(div.gallery)").addClass("home-page");

  setupHospitalLinks($);

  // setup navigation
  setupNavigation($);

  setupZipDisplay();
});

/**
 * Adds hid querystring to all links on page */
function setupHospitalLinks($: JQueryStatic) {
  const hid = getUrlVars()["hid"],
    querystring = `hid=${hid}`;

  $("a").each(function (ix: number, el: Element) {
    const $a = $(el);
    let href = $a.attr("href");

    if (hid) {
      if (!$a.hasClass("nohid")) {
        if (href) {
          if (
            hid &&
            href !== "#" &&
            !href.match("javascript:") &&
            !href.match("tel:") &&
            !href.match("hid=") &&
            !href.match("#content")
          ) {
            href += (href.match(/\?/) ? "&" : "?") + querystring;
            $a.attr("href", href);
          }
        }
      }
    }
    if (href) {
      if (href == "#") {
        $a.click(function () {
          return false;
        });
      }
    }
  });
}

function setupTrustWave() {
  const trustwave = document.querySelector(
    "#trustwaveSealImage"
  ) as HTMLElement;
  if (trustwave) {
    trustwave.setAttribute("tabindex", "0");
    trustwave.removeAttribute("title");
    trustwave.addEventListener("keydown", function (e: KeyboardEvent) {
      if (e.code === "Enter") {
        window.open(
          "https://sealserver.trustwave.com/cert.php?customerId=ae36827e5d6942099020d618408807df&amp;size=105x54&amp;style=invert",
          "c_TW",
          "location=no, toolbar=no, resizable=yes, scrollbars=yes, directories=no, status=no, width=615, height=720"
        );
        return false;
      }
      return false;
    });
  }
}
